// import React, { useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import {
//   FiGrid,
//   FiHome,
//   FiList,
//   FiBriefcase,
//   FiFileText,
//   FiUser,
//   FiLogOut,
//   FiChevronLeft,
//   FiChevronRight,
//   FiStar,
//   FiAward,
//   FiZap,
// } from "react-icons/fi";
// import "./Sidebar.css";
// import Swal from "sweetalert2";
// import { FiImage } from "react-icons/fi";
// const Sidebar = ({ isOpen, toggleSidebar, onLogout, user }) => {
//   const location = useLocation();
//   const userData = user || JSON.parse(localStorage.getItem("user") || "{}");
//   const userType = userData?.user_type?.toLowerCase() || "bronze";

//   const isActive = (path) => (location.pathname === path ? "active" : "");

//   const apiFetch = async (url, options = {}) => {
//     const token = localStorage.getItem("access");

//     const defaultHeaders = {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": "application/json",
//     };

//     try {
//       const response = await fetch(url, {
//         ...options,
//         headers: {
//           ...defaultHeaders,
//           ...options.headers,
//         },
//       });

//       if (response.status === 401) {
//         // Token expired → Auto logout
//         localStorage.clear();
//         if (onLogout) onLogout();

//         Swal.fire({
//           title: "Session Expired",
//           text: "Your login session has expired. Please log in again.",
//           icon: "warning",
//           timer: 2000,
//           showConfirmButton: false,
//         });

//         return null;
//       }

//       return response;
//     } catch (error) {
//       console.error("API error:", error);
//       throw error;
//     }
//   };

//   // ✅ Manual logout
//   const handleLogout = async () => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You will be logged out from the system.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, logout!",
//       cancelButtonText: "Cancel",
//       reverseButtons: true,
//       customClass: {
//         popup: "custom-swal-popup",
//       },
//     });

//     if (result.isConfirmed) {
//       try {
//         const refreshToken = localStorage.getItem("refresh");

//         await apiFetch(
//           "https://ambatturindustrialestate.com/api/accounts/logout/",
//           {
//             method: "POST",
//             headers: {
//               "Refresh-Token": refreshToken,
//             },
//           }
//         );

//         Swal.fire({
//           title: "Logged out!",
//           text: "You have been successfully logged out.",
//           icon: "success",
//           timer: 1500,
//           showConfirmButton: false,
//         }).then(() => {
//           localStorage.clear();
//           onLogout();
//         });
//       } catch (error) {
//         console.error("Logout error:", error);
//         localStorage.clear();
//         onLogout();
//       }
//     }
//   };

//   // ✅ Auto logout if token already expired (using JWT exp)
//   useEffect(() => {
//     const token = localStorage.getItem("access");
//     if (!token) return;

//     try {
//       const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT
//       const expiry = payload.exp * 1000; // convert to ms
//       const now = Date.now();

//       if (expiry <= now) {
//         // already expired → logout
//         localStorage.clear();
//         onLogout();
//         Swal.fire({
//           title: "Session Expired",
//           text: "Please log in again.",
//           icon: "warning",
//           timer: 2000,
//           showConfirmButton: false,
//         });
//       } else {
//         // set timeout for auto logout
//         const timeout = expiry - now;
//         const timer = setTimeout(() => {
//           localStorage.clear();
//           onLogout();
//           Swal.fire({
//             title: "Session Expired",
//             text: "Please log in again.",
//             icon: "warning",
//             timer: 2000,
//             showConfirmButton: false,
//           });
//         }, timeout);

//         return () => clearTimeout(timer);
//       }
//     } catch (e) {
//       console.error("Token decode error:", e);
//     }
//   }, [onLogout]);

//   const allMenuItems = [
//     {
//       path: "/dashboard",
//       label: "Dashboard",
//       icon: <FiGrid />,
//       access: ["gold"],
//     },
//     {
//       path: "/company-details",
//       label: "Company Details",
//       icon: <FiHome />,
//       access: ["gold", "silver", "bronze"],
//     },
//     { path: "/post", label: "Post List", icon: <FiList />, access: ["gold"] },
//     {
//       path: "/careers",
//       label: "Career Management",
//       icon: <FiBriefcase />,
//       access: ["gold"],
//     },
//     {
//       path: "/blogs",
//       label: "Blog Management",
//       icon: <FiFileText />,
//       access: ["gold"],
//     },
//     {
//       path: "/gallery",
//       label: "Gallery",
//       icon: <FiImage />,
//       access: ["gold", "silver"],
//     },
//     {
//       path: "/profile",
//       label: "Profile",
//       icon: <FiUser />,
//       access: ["gold", "silver", "bronze"],
//     },
//   ];

//   const menuItems = allMenuItems.filter((item) =>
//     item.access.includes(userType)
//   );

//   const getUserRoleInfo = () => {
//     switch (userType) {
//       case "gold":
//         return { name: "Gold Member", icon: <FiStar />, color: "#ffd700" };
//       case "silver":
//         return { name: "Silver Member", icon: <FiAward />, color: "#c0c0c0" };
//       case "bronze":
//         return { name: "Bronze Member", icon: <FiZap />, color: "#cd7f32" };
//       default:
//         return { name: "Member", icon: <FiUser />, color: "#6b7280" };
//     }
//   };
//   const roleInfo = getUserRoleInfo();

//   return (
//     <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
//       <div className="sidebar-content">
//         <div className="sidebar-header">
//           {isOpen && <h5>Industrial Directory</h5>}
//           <button className="toggle-btn" onClick={toggleSidebar}>
//             {isOpen ? <FiChevronLeft /> : <FiChevronRight />}
//           </button>
//         </div>

//         <div className="sidebar-menu">
//           {menuItems.map((item) => (
//             <Link
//               key={item.path}
//               className={`sidebar-menu-item ${isActive(item.path)}`}
//               to={item.path}
//               onClick={() => window.innerWidth <= 768 && toggleSidebar()}
//             >
//               <span className="menu-icon">{item.icon}</span>
//               {isOpen && <span className="menu-label">{item.label}</span>}
//             </Link>
//           ))}
//           <div className="sidebar-menu-item logout-item" onClick={handleLogout}>
//             <span className="menu-icon">
//               <FiLogOut />
//             </span>
//             {isOpen && <span className="menu-label">Logout</span>}
//           </div>
//         </div>

//         {isOpen && (
//           <div className="sidebar-footer">
//             <div className="user-profile">
//               <div
//                 className="avatar"
//                 style={{
//                   border: `2px solid ${roleInfo.color}`,
//                   color: roleInfo.color,
//                 }}
//               >
//                 {userData?.company_name?.charAt(0)?.toUpperCase() ||
//                   userData?.email?.charAt(0)?.toUpperCase() ||
//                   "U"}
//               </div>
//               <div className="user-info">
//                 <p className="username">
//                   {userData?.company_name || userData?.email || "User"}
//                 </p>
//                 <p className="user-role" style={{ color: roleInfo.color }}>
//                   {roleInfo.icon} {roleInfo.name}
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiHome,
  FiList,
  FiBriefcase,
  FiFileText,
  FiUser,
  FiLogOut,
  FiChevronLeft,
  FiChevronRight,
  FiStar,
  FiAward,
  FiZap,
} from "react-icons/fi";
import "./Sidebar.css";
import Swal from "sweetalert2";
import { FiImage } from "react-icons/fi";

const Sidebar = ({ isOpen, toggleSidebar, onLogout, user }) => {
  const location = useLocation();
  const [userProfile, setUserProfile] = useState(user || {});
  const [loading, setLoading] = useState(!user);
  const userType = userProfile?.user_type?.toLowerCase() || "bronze";

  const isActive = (path) => (location.pathname === path ? "active" : "");

  const apiFetch = async (url, options = {}) => {
    const token = localStorage.getItem("access");

    const defaultHeaders = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          ...defaultHeaders,
          ...options.headers,
        },
      });

      if (response.status === 401) {
        // Token expired → Auto logout
        localStorage.clear();
        if (onLogout) onLogout();

        Swal.fire({
          title: "Session Expired",
          text: "Your login session has expired. Please log in again.",
          icon: "warning",
          timer: 2000,
          showConfirmButton: false,
        });

        return null;
      }

      return response;
    } catch (error) {
      console.error("API error:", error);
      throw error;
    }
  };

  // ✅ Fetch user profile
  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const response = await apiFetch(
        "https://ambatturindustrialestate.com/api/api/profile/"
      );

      if (response && response.ok) {
        const profileData = await response.json();
        setUserProfile(profileData);
      } else {
        console.error("Failed to fetch user profile");
        setUserProfile(user || {});
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setUserProfile(user || {});
    } finally {
      setLoading(false);
    }
  };

  // ✅ Manual logout
  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from the system.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-popup",
      },
    });

    if (result.isConfirmed) {
      try {
        const refreshToken = localStorage.getItem("refresh");

        await apiFetch(
          "https://ambatturindustrialestate.com/api/accounts/logout/",
          {
            method: "POST",
            headers: {
              "Refresh-Token": refreshToken,
            },
          }
        );

        Swal.fire({
          title: "Logged out!",
          text: "You have been successfully logged out.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          localStorage.clear();
          onLogout();
        });
      } catch (error) {
        console.error("Logout error:", error);
        localStorage.clear();
        onLogout();
      }
    }
  };

  // ✅ Auto logout if token already expired (using JWT exp)
  useEffect(() => {
    const token = localStorage.getItem("access");
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT
      const expiry = payload.exp * 1000; // convert to ms
      const now = Date.now();

      if (expiry <= now) {
        // already expired → logout
        localStorage.clear();
        onLogout();
        Swal.fire({
          title: "Session Expired",
          text: "Please log in again.",
          icon: "warning",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        // set timeout for auto logout
        const timeout = expiry - now;
        const timer = setTimeout(() => {
          localStorage.clear();
          onLogout();
          Swal.fire({
            title: "Session Expired",
            text: "Please log in again.",
            icon: "warning",
            timer: 2000,
            showConfirmButton: false,
          });
        }, timeout);

        return () => clearTimeout(timer);
      }
    } catch (e) {
      console.error("Token decode error:", e);
    }
  }, [onLogout]);

  // ✅ Fetch profile on component mount if user prop is not provided
  useEffect(() => {
    if (!user) {
      fetchUserProfile();
    } else {
      setUserProfile(user);
    }
  }, [user]);

  const allMenuItems = [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: <FiGrid />,
      access: ["gold"],
    },
    {
      path: "/company-details",
      label: "Company Details",
      icon: <FiHome />,
      access: ["gold", "silver", "bronze"],
    },
    { path: "/post", label: "Post List", icon: <FiList />, access: ["gold"] },
    {
      path: "/careers",
      label: "Career Management",
      icon: <FiBriefcase />,
      access: ["gold"],
    },
    {
      path: "/blogs",
      label: "Blog Management",
      icon: <FiFileText />,
      access: ["gold"],
    },
    {
      path: "/gallery",
      label: "Gallery",
      icon: <FiImage />,
      access: ["gold", "silver"],
    },
    {
      path: "/profile",
      label: "Profile",
      icon: <FiUser />,
      access: ["gold", "silver", "bronze"],
    },
  ];

  const menuItems = allMenuItems.filter((item) =>
    item.access.includes(userType)
  );

  const getUserRoleInfo = () => {
    switch (userType) {
      case "gold":
        return { name: "Gold Member", icon: <FiStar />, color: "#ffd700" };
      case "silver":
        return { name: "Silver Member", icon: <FiAward />, color: "#c0c0c0" };
      case "bronze":
        return { name: "Bronze Member", icon: <FiZap />, color: "#cd7f32" };
      default:
        return { name: "Member", icon: <FiUser />, color: "#6b7280" };
    }
  };

  const roleInfo = getUserRoleInfo();

  // Get user display name with fallbacks
  const getDisplayName = () => {
    if (loading) return "Loading...";
    return (
      userProfile?.company_name ||
      userProfile?.ceo_name ||
      userProfile?.email ||
      "User"
    );
  };

  // Get avatar initial
  const getAvatarInitial = () => {
    if (loading) return "U";
    return (
      userProfile?.company_name?.charAt(0)?.toUpperCase() ||
      userProfile?.ceo_name?.charAt(0)?.toUpperCase() ||
      userProfile?.email?.charAt(0)?.toUpperCase() ||
      "U"
    );
  };

  // Get CEO name if available
  const getCeoName = () => {
    if (loading) return null;
    return userProfile?.ceo_name || null;
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="sidebar-content">
        <div className="sidebar-header">
          {isOpen && <h5>Industrial Directory</h5>}
          <button className="toggle-btn" onClick={toggleSidebar}>
            {isOpen ? <FiChevronLeft /> : <FiChevronRight />}
          </button>
        </div>

        <div className="sidebar-menu">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              className={`sidebar-menu-item ${isActive(item.path)}`}
              to={item.path}
              onClick={() => window.innerWidth <= 768 && toggleSidebar()}
            >
              <span className="menu-icon">{item.icon}</span>
              {isOpen && <span className="menu-label">{item.label}</span>}
            </Link>
          ))}
          <div className="sidebar-menu-item logout-item" onClick={handleLogout}>
            <span className="menu-icon">
              <FiLogOut />
            </span>
            {isOpen && <span className="menu-label">Logout</span>}
          </div>
        </div>

        {isOpen && (
          <div className="sidebar-footer">
            <div className="user-profile">
              <div
                className="avatar"
                style={{
                  border: `2px solid ${roleInfo.color}`,
                  color: roleInfo.color,
                  boxShadow: `0 0 8px ${roleInfo.color}40`,
                }}
              >
                {getAvatarInitial()}
              </div>
              <div className="user-info">
                <p className="username">{getDisplayName()}</p>
                {getCeoName() && (
                  <p className="ceo-name">CEO: {getCeoName()}</p>
                )}
                <p className="user-role" style={{ color: roleInfo.color }}>
                  {roleInfo.icon} {roleInfo.name}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
